import { getLangFromLocale } from '@transferwise/components';
import React from 'react';
import { createIntl, createIntlCache } from 'react-intl';

import { commonMessages } from '../localisation/messages/common';

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();

export default (translationKey, locale, parameters = {}) => {
  const lang = getLangFromLocale(locale) === 'zh' ? locale : getLangFromLocale(locale);
  const intl = createIntl(
    {
      locale: lang,
      messages: { ...commonMessages.en, ...commonMessages[lang] } || commonMessages.en,
    },
    cache,
  );
  return translationKey && intl.formatMessage({ id: translationKey }, parameters);
};
